module.exports = __webpack_public_path__ + "static/media/file-lines-regular-full.87aed813.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/file-lines-regular-full.svg
// module id = 2587
// module chunks = 0